import {IconPlus} from "@tabler/icons-react";
import {Modal} from "@ui";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {PrimaryButton, SecondaryButton} from "@/components/Button";

import {findBankData} from "../../../adapters/bankListAdapter";
import useGetAccountPagoMovil from "../../../hooks/wallet/useGetAccountPagoMovil";
import {useBalanceStore} from "../../../store/useBalance.store";
import AddPagoMovilForm from "../../Forms/AddPagoMovil";
import BaseModal from "../index";
import styles from "./pagoMovilListModal.module.css";

const PagoMovilListModal = () => {
  const {t} = useTranslation();
  const {data, isLoading, refetch} = useGetAccountPagoMovil();

  const [addModalVisible, setAddModalVisible] = useState(false);
  const [addModalKey, setAddModalKey] = useState(0);

  const pagoMovilListModalVisible = useBalanceStore(state => state.pagoMovilListModalVisible);
  const handlePagoMovilListModal = useBalanceStore(state => state.handlePagoMovilListModal);

  const handleAddModal = () => {
    setAddModalVisible(prev => {
      const next = !prev;
      if (next) {
        setAddModalKey(k => k + 1); // increment key when opening
      }
      return next;
    });
  };

  // Handler to close modal and refetch list after add
  const handleAddSuccess = () => {
    handleAddModal();
    refetch();
  };

  return (
    <>
      {/* ...removed inline style, now using CSS module... */}
      <Modal
        title={
          <div className={styles.modalHeader}>
            <span className={styles.modalTitle}>{t("mobilePaymentTitle")}</span>
            <button
              type="button"
              onClick={handleAddModal}
              className={styles.addBtn}
              aria-label={t("mobilePaymentBtnAdd")}
            >
              <IconPlus
                size={18}
                stroke={2.5}
              />
            </button>
          </div>
        }
        open={pagoMovilListModalVisible}
        onCancel={handlePagoMovilListModal}
        footer={null}
        centered
        width={600}
        styles={{
          content: {
            background:
              "linear-gradient(0deg, #4C4C57, #4C4C57), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))",
            borderRadius: "12px",
            maxHeight: "80vh",
            display: "flex",
            flexDirection: "column",
          },
          header: {
            background: "transparent",
            marginBottom: "20px",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: 0,
          },
          body: {
            padding: "0 24px",
            overflowY: "auto",
            flex: 1,
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            height: "100%",
          }}
        >
          {/* Pago Movil List */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              flex: 1,
              overflowY: "auto",
              paddingRight: "8px",
              minHeight: 0,
            }}
          >
            {isLoading ? (
              <div style={{color: "var(--text-secondary)", textAlign: "center"}}>{t("loading")}...</div>
            ) : data && data.length > 0 ? (
              data.map((item, index) => (
                <div key={item.ID}>
                  <div className={styles["pago-movil-item"]}>
                    {/* Content section with bank and phone info */}
                    <div className={styles["pago-movil-content"]}>
                      {/* Bank information row */}
                      <div className={styles["pago-movil-info-row"]}>
                        <span className={styles["pago-movil-label"]}>{t("mobilePaymentBank")}:</span>
                        <span className={styles["pago-movil-value"]}>{findBankData(item)?.bank_name}</span>
                      </div>

                      {/* Phone information row */}
                      <div className={styles["pago-movil-info-row"]}>
                        <span className={styles["pago-movil-label"]}>{t("mobilePaymentPhone")}:</span>
                        <span className={styles["pago-movil-value"]}>{item.phone_number}</span>
                      </div>
                    </div>
                  </div>
                  {/* Separator line between items, but not after the last item */}
                  {index < data.length - 1 && (
                    <div
                      style={{
                        borderTop: "1px solid #666",
                        margin: "0 16px",
                      }}
                    />
                  )}
                </div>
              ))
            ) : (
              <div
                style={{
                  color: "var(--text-primary)",
                  textAlign: "center",
                  padding: "40px 20px",
                }}
              >
                {t("noDataAvailable")}
              </div>
            )}
          </div>

          {/* Action Buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "16px",
              marginTop: "20px",
              paddingTop: "20px",
              paddingBottom: "20px",
              borderTop: "1px solid #666",
              flexShrink: 0,
            }}
          >
            <PrimaryButton
              onClick={handlePagoMovilListModal}
              style={{
                borderRadius: "6px",
                minWidth: "100px",
              }}
            >
              {t("mobilePaymentBtnBack")}
            </PrimaryButton>
            <SecondaryButton
              onClick={handleAddModal}
              style={{
                borderRadius: "6px",
                minWidth: "100px",
              }}
            >
              {t("mobilePaymentBtnAdd")}
            </SecondaryButton>
          </div>
        </div>
      </Modal>

      {/* Add Pago Movil Modal */}
      <BaseModal
        title={t("mobilePaymentAdd")}
        state={addModalVisible}
        closeModal={handleAddModal}
        width={420}
      >
        <AddPagoMovilForm
          key={addModalKey}
          onSuccess={handleAddSuccess}
          onCancel={handleAddModal}
        />
      </BaseModal>
    </>
  );
};

export default PagoMovilListModal;
